<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('settings.settingsLabel') }}</span>
        <h3 class="page-title">{{ $t('settings.integrations.integrations') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/ustawienia')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('settings.backToSettings') }}
      </d-button>
      </d-col>
    </d-row>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">{{ $t('settings.integrations.name') }}</th>
            <th scope="col" class="border-0">{{ $t('settings.integrations.status') }}</th>
            <th scope="col" class="border-0">{{ $t('ui.actions') }}</th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr
            v-for="(integration, index) of integrations"
            :key="'integration-' + index">
            <td class="align-middle">
              {{ integration.name }}
            </td>
            <td class="align-middle">
              <span
                v-if="integration.enabled"
                class="text-success">
                {{ $t('settings.integrations.enabled') }}
              </span>
              <span
                v-else
                class="text-danger">
                {{ $t('settings.integrations.disabled') }}
              </span>
            </td>
            <td
              class="align-middle"
              style="width: 80px;">
              <d-button
                v-if="integration.enabled"
                theme="danger"
                @click.native="disableIntegration(integration.id)"
                class="mr-2"
                :title="$t('settings.integrations.disableIntegration')"
                :disabled="statusChangeInProgress">
                <i class="material-icons">do_not_disturb_on</i>
              </d-button>
              <d-button
                v-if="!integration.enabled"
                theme="success"
                @click.native="enableIntegration(integration.id)"
                class="mr-2"
                :title="$t('settings.integrations.enableIntegration')"
                :disabled="statusChangeInProgress">
                <i class="material-icons">done</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="integrations.length === 0">
            <td
              colspan="3"
              class="text-center">
              {{ $t('settings.integrations.noIntegrationsToDisplay') }}&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        {{ $t('ui.dataLoading') }}&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
      </d-alert>
    </d-card>
  </d-container>
</template>

<script>
import FormUtils from './../utils/FormUtils.js';
import ListUtils from './../utils/ListUtils.js';
import Vue from 'vue';

export default {
  name: 'integrations',
  data() {
    return {
      integrations: [],
      loaded: false,
      loadError: false,
      statusChangeInProgress: false
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      ListUtils.loadItemsData(this, '/integrations/items', 'integrations');
    },
    enableIntegration (integrationID) {
      this.statusChangeInProgress = true;

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/integrations/update/' + integrationID,
        formData: {
          enabled: 1
        },
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('softlab.forceUpdateErrorText'),
        successAction: () => {
          this.statusChangeInProgress = false;

          Vue.swal({
            title: this.$t('settings.integrations.integrationHasBeenEnabled'),
            html: '',
            type: 'success',
            timer: 2000,
            confirmButtonText: this.$t('ui.ok'),
            buttonsStyling: true
          });

          this.loadData();
        },
        failAction: () => {
          this.statusChangeInProgress = false;
        }
      });
    },
    disableIntegration (integrationID) {
      this.statusChangeInProgress = true;

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/integrations/update/' + integrationID,
        formData: {
          enabled: 0
        },
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('softlab.forceUpdateErrorText'),
        successAction: () => {
          this.statusChangeInProgress = false;

          Vue.swal({
            title: this.$t('settings.integrations.integrationHasBeenDisabled'),
            html: '',
            type: 'success',
            timer: 2000,
            confirmButtonText: this.$t('ui.ok'),
            buttonsStyling: true
          });

          this.loadData();
        },
        failAction: () => {
          this.statusChangeInProgress = false;
        }
      });
    }
  }
};
</script>
